import {
  RESET_UPLOAD_STATUS,
  SET_ERROR_UPLOAD_STATUS,
  SET_FILE_UPLOADED_SUCCESSFULLY,
  SET_FILE_UPLOAD_FAILURE,
  SET_SUCCESS_UPLOAD_STATUS,
  UPDATE_UPLOADED_FILE_NAME,
  UPDATE_UPLOADED_FILE_STATE,
  UPDATE_FLASHBAR_STATE,
  RESET_FLASHBAR_STATE,
} from "../types/bulkCreateRequestTypes";
import {BulkCreateRequestActions} from "../actions/bulkCreateRequestActions";
import {FileUploadDetails, FileUploadStates} from "../../../interfaces/creationFlowInterfaces";
import {BULK_UPLOAD_FLASHBAR_STATE, EMPTY} from "../../constants/swiftConstants";
import {FlashbarProps} from "@amzn/awsui-components-react-v3";

const fileUploadStates: FileUploadStates = {
    isUploadInProgress: false,
    uploadProgress: 0,
};

const initialState: FileUploadDetails = {
    uploadStatus: "",
    uploadedFileName: "",
    uploadStates: fileUploadStates,
    isFileUploaded: false,
    flashbarStates: []
};

const bulkCreateRequestReducer = (
    state = initialState,
    action: BulkCreateRequestActions
): FileUploadDetails => {
    switch (action.type) {
        case SET_SUCCESS_UPLOAD_STATUS:
            return {
                ...state,
                uploadStatus: BULK_UPLOAD_FLASHBAR_STATE.SUCCESS,
            };
        case SET_ERROR_UPLOAD_STATUS:
            return {
                ...state,
                uploadStatus: BULK_UPLOAD_FLASHBAR_STATE.ERROR,
            };
        case RESET_UPLOAD_STATUS:
            return {
                ...state,
                uploadStatus: EMPTY,
            };
        case UPDATE_UPLOADED_FILE_NAME:
            return {
                ...state,
                uploadedFileName: action.payload as string,
            };
        case UPDATE_UPLOADED_FILE_STATE:
            return {
                ...state,
                uploadStates: {
                    ...state.uploadStates,
                    ...(action.payload as FileUploadStates),
                },
            };
        case SET_FILE_UPLOADED_SUCCESSFULLY:
            return {
                ...state,
                isFileUploaded: true,
            };
        case SET_FILE_UPLOAD_FAILURE:
            return {
                ...state,
                isFileUploaded: false,
            };
        case UPDATE_FLASHBAR_STATE:
            return {
                ...state,
                flashbarStates: [{
                    ...state.flashbarStates,
                    ...(action.payload as FlashbarProps.MessageDefinition)
                }]
            }
        case RESET_FLASHBAR_STATE:
            return {
                ...state,
                flashbarStates: []
            }
        default:
            return state;
    }
};

export default bulkCreateRequestReducer;